/**
 * 品题浓缩结果面向学习者展示：去掉 PAP / IPTTQ / CTTQ 等系统域术语。
 * 历史数据可能仍含「PAP 视角下的…」标题，展示层必须清洗。
 */
export function stripIpttqDomainTerms(value: string): string {
  return String(value || '')
    .replace(/\bIPTTQ\b/gi, '')
    .replace(/\bCTTQ\b/gi, '')
    .replace(/\bPAP\b/gi, '')
    .replace(/P\s*A\s*P/gi, '')
    .replace(/\s{2,}/g, ' ')
    .replace(/^[·\-—、,\s]+|[·\-—、,\s]+$/g, '')
    .replace(/([：:])\s*(视角|角度|框架)/g, '$1$2')
    .replace(/^(视角|角度)下的/, '')
    .replace(/^(视角|角度)下[的]?/, '')
    .trim();
}

/**
 * 备注面向展示：去掉产品操作文案，以及年龄/年级教学元说明
 * （年龄只影响生成难度，不应出现在备注里）。
 */
export function scrubIpttqLearnerFacingNotes(value: unknown): string | null {
  const text = stripIpttqDomainTerms(String(value || '').trim());
  if (!text) return null;
  if (
    /新建品题|自动创建|工具栏|红灯提示|诱导题库前|更新 Skill|更新品题浓缩结果|请先更新|LLM 刷新未成功/i
      .test(text)
  ) {
    return null;
  }

  const cleaned = text
    .split(/(?<=[。！？；;\n])/)
    .map((part) => part.trim())
    .filter((part) => {
      if (!part) return false;
      return !/(?:\d+\s*[-~～到至]?\s*\d*\s*岁|\d+\s*岁|适用年级|年级适配|年龄区间|年龄体验|梯度适配|认知水平|实龄|超前设定)/.test(part);
    })
    .join('')
    .replace(/\s{2,}/g, ' ')
    .trim();

  return cleaned || null;
}
